module.exports = __webpack_public_path__ + "static/media/20231026-DSC_4723.51f32da8.jpg";